import React from "react";
import { TextStyle } from "react-native";
import { IconSymbol } from "@/components/ui/IconSymbol";
import { useTheme } from "@/hooks/useTheme";
import { ENTITY_ICONS, EntityIconKey } from "@/constants/icons";

export interface PreviewIconProps {
  entityType?: string;
  size?: number;
  style?: TextStyle;
  iconColor?: string;
}

// Map singular entity types to icon keys
const ENTITY_TYPE_TO_KEY: Record<string, EntityIconKey> = {
  project: "projects",
  shift: "shifts",
  course: "courses",
  user: "users",
  client: "clients",
  contact: "contacts",
  time_card: "time_cards",
  incident: "incidents",
  investigation: "investigations",
  application: "applications",
  invoice: "invoices",
  estimate: "estimates",
  billing_item: "billing_items",
};

export function PreviewIcon({ entityType, size = 32, style, iconColor }: PreviewIconProps) {
  const { colors } = useTheme();
  const resolvedColor = iconColor || colors.text;

  if (!entityType) return null;

  const iconKey = ENTITY_TYPE_TO_KEY[entityType];
  if (!iconKey || !ENTITY_ICONS[iconKey]) return null;

  return (
    <IconSymbol
      name={ENTITY_ICONS[iconKey]}
      size={size}
      color={resolvedColor}
      style={{ opacity: 0.8, alignSelf: "center", ...style }}
    />
  );
}
